import administratorRoutes from "./AdministratorRoutes";
import AdministratorStore from "./AdministratorStore";
import AdministratorLinks from "./AdministratorLinks";

export default {
  install(Vue, options) {
    if (options.router) {
      options.router.addRoute(...administratorRoutes);
    }
    if (options.store) {
      options.store.registerModule("Administrator", AdministratorStore);
    }
    options.store.commit("Dashboard/SET_LINKS", AdministratorLinks);
  },
};
